module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAUCAYAAAC9BQwsAAAAk0lEQVQ4T2P06Lzqx/T/30wGBgYJBuLAi3+MTOmMXh2Xn5OgCWb0C5DG/yDetgpdRmIshKkf1YgltEYDB08Sol7g/P/HaENMWmVk+n8EpA6eVonRhKwGp0ZdOW6wusuPvmI1E6fGifHKYA35C+/i1PiCgYFBHF1WiIcFLPTuyx9sGkEZ+ZI/AwPjDBJKgRcMDP8zABRUelRcooo1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.png
// module id = UqHI
// module chunks = 1